import { Routes, Route } from "react-router-dom";
import { useContext } from "react";

import {
  LoginPage,
  CreatePasswordPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  DashboardPage,
  MembersPage,
  MemberManagementPage,
  MemberAuthenticationPage,
  MemberOTPPage,
  MemberSignaturePage,
  MemberSuccessPage,
  CompliancePage,
  GroupsPage,
  GroupManagementPage,
  UsersPage,
  AgentsPage,
  BranchesPage,
  ReportsPage,
  HealthDashboardPage,
  ClaimsPage,
  ClaimManagementPage,
  PaymentsPage,
  FuneralInvoicesPage,
  FuneralProductsPage,
  FuneralCustomersPage,
  FuneralManagementPage,
  DocumentPage,
  CommunicationPage,
  AdminLoginPage,
  AdminDashboardPage,
  AdminUsersPage,
  AdminGroupsPage,
  AdminGroupManagementPage,
  AdminDocumentPage,
  AdminCommunicationPage,
  AdminReconPage,
  AdminEmailQueuePage,
  AdminSmsQueuePage,
  AdminReportConfigPage,
  MaintenancePage,
  MaintenanceRunPage,
} from "../pages";

import { AuthContext } from "../context/AuthContext";

const Router = () => {
  const { currentGroup } = useContext(AuthContext);

  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/compliance" element={<CompliancePage />} />
      <Route path="/maintenance" element={<MaintenancePage />} />
      <Route path="/maintenance/:runId" element={<MaintenanceRunPage />} />
      <Route path="/members" element={<MembersPage />} />
      <Route path="/members/:memberId" element={<MemberManagementPage />} />
      <Route
        path="/members/authenticate/:memberId"
        element={<MemberAuthenticationPage />}
      />
      <Route path="/members/otp/:memberId" element={<MemberOTPPage />} />
      <Route
        path="/members/signature/:memberId"
        element={<MemberSignaturePage />}
      />
      <Route path="/members/success/:memberId" element={<MemberSuccessPage />} />
      <Route path="/groups" element={<GroupsPage />} />
      <Route
        path="/groups/:groupId"
        element={<GroupManagementPage group={currentGroup} />}
      />
      <Route path="/groups/:groupId/document" element={<DocumentPage />} />
      <Route
        path="/groups/:groupId/communication"
        element={<CommunicationPage />}
      />

      <Route path="/users" element={<UsersPage />} />
      <Route path="/agents" element={<AgentsPage />} />
      <Route path="/branches" element={<BranchesPage />} />
      <Route path="/reports" element={<ReportsPage />} />
      <Route path="/claims" element={<ClaimsPage />} />
      <Route path="/claims/:claimId" element={<ClaimManagementPage />} />
      <Route path="/payments" element={<PaymentsPage />} />

      {/* Funeral Parlor */}
      <Route path="/funeral-invoices" element={<FuneralInvoicesPage />} />
      <Route path="/funeral-products" element={<FuneralProductsPage />} />
      <Route path="/funeral-customers" element={<FuneralCustomersPage />} />
      <Route path="/funeral/:invoiceId" element={<FuneralManagementPage />} />

      <Route path="/health-dashboard" element={<HealthDashboardPage />} />

      <Route path="/" element={<LoginPage />} />
      <Route path="/create-password/:token" element={<CreatePasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

      {/* Admin Pages */}
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/groups" element={<AdminGroupsPage />} />
      <Route
        path="/admin/groups/:groupId"
        element={<AdminGroupManagementPage group={currentGroup} />}
      />
      <Route
        path="/admin/groups/:groupId/document"
        element={<AdminDocumentPage />}
      />
      <Route
        path="/admin/groups/:groupId/communication"
        element={<AdminCommunicationPage />}
      />
      <Route path="/admin/recon" element={<AdminReconPage />} />
      <Route path="/admin/email-queue" element={<AdminEmailQueuePage />} />
      <Route path="/admin/sms-queue" element={<AdminSmsQueuePage />} />
      <Route path="/admin/maintenance" element={<MaintenancePage adminLayout />} />
      <Route
        path="/admin/maintenance/:runId"
        element={<MaintenanceRunPage adminLayout />}
      />
      <Route path="/report-config" element={<AdminReportConfigPage adminLayout={false} />} />
      <Route path="/admin/report-config" element={<AdminReportConfigPage />} />
    </Routes>
  );
};

export default Router;
